import React from 'react';
import { Button } from './Button';
import { FileText } from 'lucide-react';
export function FederalRegsOverview() {
  return <section className="py-16 bg-legal-light border-y border-legal-border" data-id="element-115">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="bg-white rounded-lg shadow-sm border-l-4 border-legal-red p-8 md:p-10 relative" data-id="element-117">
          <div className="absolute top-8 right-8 text-legal-border opacity-20" data-id="element-118">
            <FileText className="w-24 h-24" data-id="element-119" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-legal-dark mb-6 relative z-10" data-id="element-120">
            Federal Regulations That May Apply To Your Case
          </h2>

          <div className="prose prose-lg text-legal-gray max-w-4xl relative z-10 space-y-6" data-id="element-121">
            <p data-id="element-122">
              The Federal Motor Carrier Safety Regulations (FMCSR) govern the
              operation of commercial motor vehicles in interstate commerce.
              These regulations are established and enforced by the Federal
              Motor Carrier Safety Administration, which can be found at{' '}
              <a href="http://www.fmcsa.dot.gov" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-123">
                www.fmcsa.dot.gov
              </a>
              .
            </p>
            <p data-id="element-124">
              These rules are codified in Title 49 of the Federal Code.
              Understanding Title 49 Law is critical when investigating a truck
              accident, as violations of these regulations often establish
              negligence on the part of the driver or the motor carrier.
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-legal-border flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-125">
            <div className="inline-flex items-center px-4 py-2 bg-legal-dark text-white text-sm font-bold rounded shadow-sm uppercase tracking-wider" data-id="element-126">
              Key Regulations Below
            </div>
            <Button href="11014.html" variant="primary" icon="mail" data-id="element-127">
              Contact Us About Your Case
            </Button>
          </div>
        </div>
      </div>
    </section>;
}